import { ButtonComponent } from "./appButton";

export const AppButton = ButtonComponent;
